/**
 * Deployment environment for the dashboard.
 *
 * Set via VITE_DONEVERSE_ENV per deployment (production | stage | development).
 * Falls back to Vite's MODE so local builds still report sensibly.
 */
export const DONEVERSE_ENV: string =
  (import.meta.env.VITE_DONEVERSE_ENV as string | undefined) || import.meta.env.MODE || 'development'

export const IS_STAGE = DONEVERSE_ENV === 'stage'

/**
 * Commit SHA of the running build, set by the deploy workflow through
 * VITE_DONEVERSE_RELEASE. Local and ad-hoc builds have none. An empty or blank
 * value resolves to undefined rather than a placeholder: a literal 'unknown'
 * would match filters and group every unversioned build into one fake release
 * (the same rule the API applies to DONEVERSE_RELEASE).
 */
export function resolveRelease(raw: string | undefined): string | undefined {
  const trimmed = raw?.trim()
  return trimmed ? trimmed : undefined
}

export const DONEVERSE_RELEASE = resolveRelease(import.meta.env.VITE_DONEVERSE_RELEASE as string | undefined)

/**
 * Keep local browser telemetry out of the shared Better Stack sources unless a
 * developer deliberately opts in. Deployed builds remain enabled by default.
 */
export function resolveObservabilityEnabled(isDev: boolean, localOverride?: string): boolean {
  return !isDev || localOverride === 'true'
}

export const OBSERVABILITY_ENABLED = resolveObservabilityEnabled(
  import.meta.env.DEV,
  import.meta.env.VITE_OBSERVABILITY_ENABLED as string | undefined,
)
